// Set token
export const setKeycloakToken = (token) => {
  if (token) {
    // Store token in localStorage
    localStorage.setItem("keycloak-token", token);
  } else {
    // Remove token from localStorage
    localStorage.removeItem("keycloak-token");
  }
};

// Clear token
export const clearKeycolakToken = () => {
  // Remove token from localStorage
  localStorage.removeItem("keycloak-token");
};
